import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "~/atoms/button";

const descriptionMaxLength = 300;

interface Props {
  description: string | null;
}
export default function WorkflowDescription({ description }: Props) {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  if (!description) {
    return null;
  }

  return (
    <div className="border-border/30 bg-secondary/50 rounded-md border p-4">
      <div className="text-sm font-semibold">
        {t("commons.workflow.description")}
      </div>
      <div className="text-sm whitespace-pre-wrap">
        {expanded || description.length < descriptionMaxLength
          ? description
          : `${description.slice(0, descriptionMaxLength).trim()}...`}
      </div>
      {description.length > descriptionMaxLength ? (
        <div className="flex justify-center">
          <Button variant="link" onClick={() => setExpanded(!expanded)}>
            {expanded
              ? t("commons.buttons.collapse")
              : t("commons.buttons.expand")}
          </Button>
        </div>
      ) : null}
    </div>
  );
}
